var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7521 48.5152C44.1494 43.3874 45.8827 38.0068 44.6369 33.2582C41.7299 26.4693 27.9716 23.2555 21.3452 24.4652C17.2105 31.4166 18.9258 39.993 19.6841 47.9193L43.7521 48.5152Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6509 48.2088V25.0977C37.2842 26.4157 42.8995 29.1963 44.6328 33.2588C45.8786 38.0254 44.1453 43.3879 43.7481 48.5157L31.6328 48.2088H31.6509Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4375 96.6148C35.0847 96.6689 38.6778 96.5064 42.2347 96.1453V63.5911L41.025 63.0675C38.3528 61.8939 35.0486 60.5578 31.4375 60.0703V96.6328V96.6148Z",
    fill: "#B2D8DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4378 96.6148C27.7906 96.6689 24.1976 96.5064 20.6406 96.1453V63.5911L21.8503 63.0675C24.5226 61.8939 27.8267 60.5578 31.4378 60.0703V96.6328V96.6148Z",
    fill: "#B2D8DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7266 53.6426H39.128V62.9412C34.0002 67.0217 28.8543 67.1842 23.7266 62.9412V53.6426Z",
    fill: "#E0AC7E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1012 34.5582C22.9165 34.1248 20.8221 36.3637 20.4429 38.5484C20.0818 40.5526 19.829 42.6109 19.7387 44.6873C19.6846 44.6873 19.9915 44.6873 19.5582 44.6873C19.1248 44.6873 17.6804 45.0123 17.7526 46.9262C17.8068 48.3526 19.0526 52.5054 20.6776 51.8373C23.0429 58.1748 26.2387 61.7679 31.4568 63.0318C31.5471 62.8693 31.5832 62.9957 31.6734 62.9415V35.2623C29.5609 35.2623 27.4665 35.0457 25.1193 34.5943L25.1012 34.5582Z",
    fill: "#F2C196"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9917 34.5582C40.1764 34.1248 42.2708 36.3637 42.65 38.5484C43.0111 40.5526 43.2639 42.6109 43.3542 44.6873C43.4083 44.6873 43.1014 44.6873 43.5347 44.6873C43.9681 44.6873 45.4125 45.0123 45.3403 46.9262C45.2861 48.3526 44.0403 52.5054 42.4153 51.8373C40.0139 58.2651 36.7819 61.804 31.4375 63.0318V35.2623C33.55 35.2623 35.6444 35.0457 37.9917 34.5943V34.5582Z",
    fill: "#EBB688"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.433 66.0645H34.0691L32.9497 70.2353H31.433H29.9163L28.7969 66.0645H31.433Z",
    fill: "#63C0DA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9526 70.1094L34.0359 85.9441L31.4359 90.6927L28.8359 85.9441L29.9193 70.1094H32.9526Z",
    fill: "#63C0DA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4312 66.0659L26.8993 70.4534L21.8438 63.0507L23.7215 62.0215C25.6174 64.0257 28.2174 65.2895 31.4312 66.0659Z",
    fill: "#F0FAFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4349 90.2604L20.3307 63.7188C10.3099 68.0521 3.86406 71.3743 2.72656 84.0854C7.27656 92.2104 18.1641 98.8729 31.4349 98.8549V90.2604Z",
    fill: "#00274C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8047 93.3293C12.2019 93.6182 12.6714 93.8349 13.0866 94.1057L13.0505 88.8516L11.8047 93.3293Z",
    fill: "#00274C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4363 90.2589V96.9575L21.0002 78.252L24.1057 74.4964L19.3752 72.9075L17.2266 65.0714L22.4085 62.8145L31.4363 90.2589Z",
    fill: "#0174A3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4321 66.0659L35.946 70.4534L41.0016 63.0507L39.1238 62.0215C37.228 64.0257 34.646 65.2895 31.4141 66.0659H31.4321Z",
    fill: "#F0FAFC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4375 90.2604L42.5417 63.7188C52.5806 68.0521 59.0083 71.3743 60.1458 84.0854C55.5958 92.2104 44.7083 98.8729 31.4375 98.8549V90.2604Z",
    fill: "#00274C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0788 93.3293C50.6816 93.6182 50.2122 93.8349 49.7969 94.1057L49.833 88.8516L51.0788 93.3293Z",
    fill: "#00274C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4375 90.2599V96.9585L41.8917 78.253L38.7861 74.4974L43.5167 72.9085L45.6472 65.0724L40.6639 62.8516L31.4375 90.2599Z",
    fill: "#0A6D94"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.885 48.5152C111.282 43.3874 113.016 38.0068 111.77 33.2582C108.863 26.4693 95.1044 23.2555 88.478 24.4652C84.3433 31.4166 86.0586 39.993 86.8169 47.9193L110.885 48.5152Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7837 48.2088V25.0977C104.417 26.4157 110.032 29.1963 111.766 33.2588C113.011 38.0254 111.278 43.3879 110.881 48.5157L98.7656 48.2088H98.7837Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5703 96.6148C102.218 96.6689 105.811 96.5064 109.368 96.1453V63.5911L108.158 63.0675C105.486 61.8939 102.181 60.5578 98.5703 60.0703V96.6328V96.6148Z",
    fill: "#B2D8DE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5707 96.6148C94.9234 96.6689 91.3304 96.5064 87.7734 96.1453V63.5911L88.9832 63.0675C91.6554 61.8939 94.9595 60.5578 98.5707 60.0703V96.6328V96.6148Z",
    fill: "#B2D8DE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8594 53.6426H106.279V62.9412C101.133 67.0217 96.0052 67.1842 90.8594 62.9412V53.6426Z",
    fill: "#E0AC7E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2106 34.5582C90.0259 34.1248 87.9315 36.3637 87.5523 38.5484C87.1912 40.5526 86.9384 42.6109 86.8481 44.6873C86.794 44.6873 87.119 44.6873 86.6676 44.6873C86.2162 44.6873 84.7898 45.0123 84.862 46.9262C84.9162 48.3526 86.162 52.5054 87.787 51.8373C90.1523 58.1748 93.3481 61.7679 98.5481 63.0318C98.6384 62.8693 98.6745 62.9957 98.7648 62.9415V35.2623C96.6523 35.2623 94.5579 35.0457 92.2106 34.5943V34.5582Z",
    fill: "#F2C196"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.124 34.5582C107.309 34.1248 109.404 36.3637 109.783 38.5484C110.144 40.5526 110.397 42.6109 110.487 44.6873C110.541 44.6873 110.216 44.6873 110.668 44.6873C111.119 44.6873 112.545 45.0123 112.473 46.9262C112.419 48.3526 111.173 52.5054 109.548 51.8373C107.147 58.2651 103.915 61.804 98.5703 63.0318V35.2623C100.683 35.2623 102.777 35.0457 105.124 34.5943V34.5582Z",
    fill: "#EBB688"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5658 66.0645H101.202L100.082 70.2353H98.5658H97.0491L95.9297 66.0645H98.5658Z",
    fill: "#63C0DA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.085 70.1094L101.169 85.9441L98.5687 90.6927L95.9688 85.9441L97.0521 70.1094H100.085Z",
    fill: "#63C0DA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5694 66.0659L94.0556 70.4534L89 63.0507L90.8778 62.0215C92.7736 64.0257 95.3736 65.2895 98.5875 66.0659H98.5694Z",
    fill: "#F0FAFC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5677 90.2604L87.4635 63.7188C77.4427 68.0521 70.9969 71.3743 69.8594 84.0854C74.4094 92.2104 85.2969 98.8729 98.5677 98.8549V90.2604Z",
    fill: "#00274C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9375 93.3293C79.3347 93.6182 79.8042 93.8349 80.2194 94.1057L80.1833 88.8516L78.9375 93.3293Z",
    fill: "#00274C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5691 90.2589V96.9575L88.1149 78.252L91.2385 74.4964L86.4899 72.9075L84.3594 65.0714L89.5233 62.8145L98.5691 90.2589Z",
    fill: "#0174A3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5649 66.0659L103.079 70.4534L108.134 63.0507L106.257 62.0215C104.361 64.0257 101.761 65.2895 98.5469 66.0659H98.5649Z",
    fill: "#F0FAFC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5703 90.2604L109.674 63.7188C119.695 68.0521 126.141 71.3743 127.279 84.0854C122.729 92.2104 111.841 98.8729 98.5703 98.8549V90.2604Z",
    fill: "#00274C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.196 93.3293C117.799 93.6182 117.347 93.8349 116.914 94.1057L116.95 88.8516L118.196 93.3293Z",
    fill: "#00274C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5703 90.2599V96.9585L109.006 78.253L105.901 74.4974L110.631 72.9085L112.78 65.0724L107.797 62.8516L98.5703 90.2599Z",
    fill: "#0A6D94"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0504 48.2264C81.556 41.6181 83.7948 34.7028 82.1879 28.5639C78.4323 19.807 60.7018 15.6722 52.1796 17.225C46.8532 26.1806 49.0559 37.2486 50.0309 47.45L81.0504 48.2264Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4531 47.8464V18.0547C72.7295 19.77 79.9517 23.345 82.1906 28.563C83.7976 34.7019 81.5587 41.6172 81.0531 48.2255L65.4531 47.8464Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1797 110.211C69.8922 110.283 74.5144 110.066 79.0825 109.597V67.6359L77.5297 66.9498C74.0991 65.4512 69.838 63.7179 65.1797 63.0859V110.211Z",
    fill: "#B2D8DE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.184 110.211C60.4715 110.283 55.8493 110.066 51.2812 109.597V67.6359L52.834 66.9498C56.2646 65.4512 60.5257 63.7179 65.184 63.0859V110.211Z",
    fill: "#B2D8DE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.25 54.834H75.1111V66.8048C68.4847 72.059 61.8764 72.2757 55.25 66.8048V54.834Z",
    fill: "#E0AC7E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.998 30.2421C54.1813 29.7004 51.4911 32.5713 50.9855 35.3879C50.5161 37.9699 50.1911 40.6241 50.0827 43.2963C50.0105 43.2963 50.4258 43.2782 49.848 43.2782C49.2702 43.2782 47.4286 43.6935 47.5188 46.1491C47.5911 47.9907 49.1799 53.3532 51.2924 52.4685C54.3438 60.6477 58.4424 65.2518 65.1772 66.8949C65.2855 66.6782 65.3397 66.8407 65.448 66.7685V31.0907C62.7397 31.0907 60.0313 30.8199 56.998 30.2241V30.2421Z",
    fill: "#F2C196"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6297 30.2421C76.4464 29.7004 79.1366 32.5713 79.6422 35.3879C80.1116 37.9699 80.4366 40.6241 80.545 43.2963C80.6172 43.2963 80.2019 43.2782 80.7797 43.2782C81.3575 43.2782 83.1991 43.6935 83.1089 46.1491C83.0366 47.9907 81.4477 53.3532 79.3352 52.4685C76.2477 60.756 72.0769 65.306 65.1797 66.8949V31.1088C67.888 31.1088 70.5964 30.8379 73.6297 30.2421Z",
    fill: "#EBB688"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1835 70.832H68.5779L67.1516 76.2306H65.1835H63.2335L61.7891 70.832H65.1835Z",
    fill: "#63C0DA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1521 76.0684L68.5424 96.4531L65.184 102.574L61.8438 96.4531L63.234 76.0684H67.1521Z",
    fill: "#63C0DA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1781 70.8328L59.3462 76.5023L52.8281 66.9509L55.2476 65.6328C57.6851 68.2148 61.0253 69.8398 65.1781 70.8328Z",
    fill: "#F0FAFC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1809 102.014L50.8809 67.8164C37.9531 73.3956 29.6656 77.6928 28.2031 94.0511C34.0712 104.523 48.1003 113.1 65.1809 113.082V102.014Z",
    fill: "#00274C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8828 105.987C40.4064 106.348 40.9842 106.637 41.5259 106.98L41.4898 100.209L39.8828 105.987Z",
    fill: "#00274C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1809 102.013V110.662L51.7295 86.5574L55.7378 81.7004L49.6351 79.6602L46.8906 69.5671L53.5351 66.6602L65.1809 102.013Z",
    fill: "#0174A3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1797 70.8328L71.0116 76.5023L77.5297 66.9509L75.1102 65.6328C72.6727 68.2148 69.3325 69.8398 65.1797 70.8328Z",
    fill: "#F0FAFC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1797 102.014L79.4797 67.8164C92.4075 73.3956 100.695 77.6928 102.157 94.0511C96.2894 104.523 82.2602 113.1 65.1797 113.082V102.014Z",
    fill: "#00274C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4946 105.987C89.971 106.348 89.3932 106.637 88.8516 106.98L88.8877 100.209L90.4946 105.987Z",
    fill: "#00274C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1797 102.014V110.663L78.6491 86.5584L74.6408 81.7014L80.7436 79.6612L83.488 69.5681L77.0783 66.6973L65.1797 102.014Z",
    fill: "#0A6D94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/Employees.013e2104c1e127c171547f031650b096.svg";
export { ForwardRef as ReactComponent };